import axios from 'axios';
import ErrorWithCause from '@helpers/ErrorWithCause';
import { SYMFONY_API_BASE_URL } from '@config/apiConfig';
const getBrandedTournamentContent = async (slug) => {
    try {
        return await axios
            .get(`${SYMFONY_API_BASE_URL}/api/influencer-page/v1/${slug}`)
            .then((response) => response.data);
    }
    catch (error) {
        throw new ErrorWithCause(error);
    }
};
export default getBrandedTournamentContent;
